import { connect } from 'react-redux';
import { getCoreLevel } from '../../../publicSession/selectors';
const mapStateToProps = (state)=>({
        corePackage: getCoreLevel(state)
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=LogoWithCoreLevel.container.js.map